var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMongo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98047 15.5C12.8465 15.5 15.9805 12.366 15.9805 8.5C15.9805 4.63401 12.8465 1.5 8.98047 1.5C5.11448 1.5 1.98047 4.63401 1.98047 8.5C1.98047 12.366 5.11448 15.5 8.98047 15.5Z",
    fill: "#13AA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8521 7.64469C10.4099 5.6933 9.36498 5.05168 9.25246 4.80654C9.12941 4.63359 9.00472 4.32598 9.00472 4.32598C9.00267 4.32078 8.99939 4.31162 8.99556 4.30273C8.98285 4.47568 8.97628 4.5424 8.81277 4.71686C8.55957 4.91482 7.26046 6.00488 7.15478 8.22191C7.05621 10.2896 8.64843 11.5218 8.86376 11.6788L8.88824 11.6962V11.6947C8.8896 11.7051 8.9566 12.1869 9.00363 12.6974H9.17234C9.21192 12.3365 9.27126 11.9781 9.35007 11.6238L9.36374 11.6149C9.46007 11.5458 9.5519 11.4707 9.63869 11.39L9.64853 11.3811C10.1063 10.9582 10.9292 9.98012 10.9211 8.4207C10.9194 8.16058 10.8963 7.90103 10.8521 7.64469ZM8.98572 10.5114C8.98572 10.5114 8.98572 7.61133 9.08142 7.61188C9.15607 7.61188 9.25273 11.3526 9.25273 11.3526C9.11984 11.3366 8.98572 10.737 8.98572 10.5114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongo);
export default __webpack_public_path__ + "static/media/Mongo.eecfd2853ad8998c1ed6ccf27b0629a0.svg";
export { ForwardRef as ReactComponent };